<template>
  <NxInput
    name="numeroDocumentoIdentidade"
    type="text"
    label="Documento de Identidade:"
    placeholder="Digite o num. do doc. de identidade"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputNumeroDocumentoIdentidade',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputNumeroDocumentoIdentidade.vue